import * as React from "react";
import styled from "styled-components";

import { theme as BackupTheme } from "src/library/utils";

import Grid from "../Hedron";

const ErrorText = styled.p`
  font-family: Roboto;
  text-align: center;
  font-size: ${({ theme }) => (theme.fonts || BackupTheme.fonts).sizes.h3};
`;

const RetryButton = styled.button`
  background: #2b10b0;
  font-size: ${({ theme }) => (theme.fonts || BackupTheme.fonts).sizes.p};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 35px;
  width: 84px;
  outline: none;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
  font-family: Roboto;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0 15px;
  transition: all ease-in-out 0, 2s;
`;

const SettingsError = () => {
  return (
    <Grid.Bounds
      height="100vh"
      valign="center"
      halign="center"
    >
      <Grid.Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <img
          onClick={() => location.reload()}
          style={{
            cursor: "pointer",
            marginBottom: "20px"
          }}
          src={`${window.location.href}/assets/mezze.svg`}
        />

        <ErrorText>
          Something went wrong retrieving site settings.
        </ErrorText>

        <ErrorText>
          Please try again or contact your platform administrator.
        </ErrorText>

        <RetryButton onClick={() => location.reload()}>
          Retry
        </RetryButton>
      </Grid.Box>
    </Grid.Bounds>
  );
};

export default SettingsError;
